import React, { useEffect, CSSProperties } from 'react'
import { definePRHeader } from '@celepar/header-estado'
import { useResponsive } from '../../hooks/useResponsive'

/**
 * Componente HeaderEstadual
 * 
 * Renderiza o header do governo do estado do Paraná.
 * Fica fixo no topo da tela com z-index máximo.
 * 
 * Reason: Usa useResponsive para garantir sincronização de altura com LogoSection e Navbar
 */
export function HeaderEstadual() {
  const { headerEstadualHeight } = useResponsive()

  useEffect(() => {
    // Registra o web component se ainda não estiver registrado
    if (!customElements.get('pr-header')) {
      definePRHeader()
      console.log('pr-header web component registrado com sucesso')
    }
  }, [])

  const containerStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 9999,
    height: `${headerEstadualHeight}px`,
    overflow: 'hidden'
  }

  return (
    <div style={containerStyle}>
      {React.createElement('pr-header', { visible: 'true' })}
    </div>
  )
}
